import { render, staticRenderFns } from "./Changepassword.vue?vue&type=template&id=c294180e&scoped=true&"
import script from "./Changepassword.vue?vue&type=script&lang=js&"
export * from "./Changepassword.vue?vue&type=script&lang=js&"
import style0 from "./Changepassword.vue?vue&type=style&index=0&id=c294180e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c294180e",
  null
  
)

export default component.exports